import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const catColumns = [
    categories.slice(0, 5),
    categories.slice(5, 10),
    categories.slice(10, 14),
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block">
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 tracking-tight leading-tight">
                KAKOBUY
                <br />
                SPREADSHEET
              </h2>
            </Link>
            <div className="w-8 h-0.5 bg-primary-500 mt-4 mb-4"></div>
            <p className="text-sm text-foreground-600 max-w-xs leading-relaxed">
              Your trusted source for verified Kakobuy products, updated daily with the latest seller
              reviews and QC photo references.
            </p>
          </div>

          {/* Category Columns */}
          {catColumns.map((col, colIdx) => (
            <div key={colIdx}>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                {colIdx === 0 ? "Categories" : colIdx === 1 ? "More" : "Other"}
              </h4>
              <div className="w-6 h-px bg-background-300 mb-4"></div>
              <ul className="space-y-2.5">
                {col.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between mt-14 pt-8 border-t border-background-200/70 gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Kakobuy Spreadsheet. All external links open on kaspreadsheet.com.
          </p>
          <div className="flex items-center gap-5">
            <Link
              to="/"
              className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors"
            >
              Home
            </Link>
            <Link
              to="/guide/how-to-use-kakobuy-spreadsheet"
              className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors"
            >
              Guide
            </Link>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors"
            >
              Kakobuy
            </a>
          </div>
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-800 transition-colors"
            >
              <i className="ri-global-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-800 transition-colors"
            >
              <i className="ri-shopping-cart-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}